import { Card, CardContent } from '@/components/ui/card';
import { TrendingDown } from 'lucide-react';

interface GapScoreCardProps {
  gap: number;
}

export function GapScoreCard({ gap }: GapScoreCardProps) {
  return (
    <Card className="border-border bg-card">
      <CardContent className="p-4 md:p-6 space-y-3">
        <div className="flex items-center gap-2">
          <TrendingDown className="h-5 w-5 text-muted-foreground" />
          <h3 className="font-semibold text-foreground">Gap Score</h3>
        </div>
        
        <div className="text-4xl font-bold text-center text-primary">
          +{gap}
        </div>
        
        <p className="text-sm text-muted-foreground leading-relaxed">
          Your gap score shows how much the AI has to improve your prompt. The goal is to close 
          this gap by giving AI more context when building a prompt.
        </p>
      </CardContent>
    </Card>
  );
}
